module.exports = __webpack_public_path__ + "img/DSC01635.336104de.jpg";